import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { Post, SocialMediaLinks } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get news from the Wordpress API.
   */
  getNews(): Observable<Post> {
    return this.httpClient.get<Post>(environment.news.baseNewsEndpoint);
  }

  /**
   * Get social media links from the Wordpress API.
   */
  getSocialMediaLinks(): Observable<SocialMediaLinks> {
    return this.httpClient.get<SocialMediaLinks>(
      environment.news.socialMediaLinksEndpoint
    );
  }
}
